export const IOS_APP_STORE_URL =
  "https://apps.apple.com/gb/app/school-wellbeing/id1663791750";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.schoolwellbeing.mobileapp&gl=GB";

export function getMobileStoreUrl(userAgent, maxTouchPoints = 0) {
  if (/android/i.test(userAgent)) {
    return ANDROID_PLAY_STORE_URL;
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return IOS_APP_STORE_URL;
  }

  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) {
    return IOS_APP_STORE_URL;
  }

  return null;
}
